export default "__VITE_ASSET__DQLTdwMw__"